import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { groupBy } from 'lodash';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { configurationRoutes } from '../../configuration/configuration-routing.module';
import { engineeringScheduleRoutes } from '../../engineering-schedule/engineering-schedule-routing.module';
import { masterRoutes } from '../../master/master-routing.module';
import { repositoryDocumentRoutes } from '../../repositorydocument/repositorydocument-routing';
import { workflowRoutes } from '../../workflow/workflow-routing.module';
import { transmittalRoutes } from '../../transmittal/transmittal-routing.module';
import { authenticationRoutes } from '../../authentication/authentication-routing.module';
import { communicationRoutes } from '../../communication/communication-routing';
import { dashboardRoutes } from '../../dashboard/dashboard-routing.module';
import { ReportRoutes } from '../../report/report-routing.module';
import { EdmsCommonHeaderComponent } from 'src/app/CommonComponents/edms-common-header/edms-common-header.component';
import { IElasticProjRedirectModel } from 'src/app/ViewModel/ElasticSearch.Model';
import { peereviewRoutes } from '../../peer-review/peer-review-routing.module';
import { FeedbackRoutes } from '../../feedback/feedback-routing';



@Component({
  selector: 'app-home-layout',
  templateUrl: './app-home-layout.component.html'
})

export class AppHomeLayoutComponent implements OnInit {
  public title = 'EIP Document Management System';
  /** Show project list (Child component data) */
  public showProjectList: boolean|null = null;
  /** Show date detail (Child component data) */
  public showDateDetails: boolean|null = null;
  /** Common header component page title (Child component data) */
  public pageTitle:string|null = null;
  /** Grouped all routes by subpath */
  public grpdSecondPath = {
    ...groupBy(authenticationRoutes, 'path'),
    ...groupBy(communicationRoutes, 'path'),
    ...groupBy(configurationRoutes, 'path'),
    ...groupBy(dashboardRoutes, 'path'),
    ...groupBy(engineeringScheduleRoutes, 'path'),
    ...groupBy(masterRoutes, 'path'),
    ...groupBy(ReportRoutes, 'path'),
    ...groupBy(repositoryDocumentRoutes, 'path'),
    ...groupBy(transmittalRoutes, 'path'),
    ...groupBy(workflowRoutes, 'path'),
    ...groupBy(peereviewRoutes, 'path')
    // ,
    // ...groupBy(FeedbackRoutes,'path')
  };
  @ViewChild('edmsprojectheader') edmsProjHeader!: EdmsCommonHeaderComponent;
  constructor(private commonService: CommonService,
    private notificationService: NotificationService,
    public _router: Router) {
  }

  ngOnInit() {
    //this.handleRoute();
  }
  /**
   * Router outlet event
   * Get component's data and set page title
   */
  handleRoute() {
    let currentUrl = this._router.url;

    if (currentUrl == '/dashboard/home') {
      this.pageTitle = "";


      this.commonService.selectedProjectId.subscribe(async (data:any) => {
        if (data && data == 9999999) {
          this.showDateDetails = false;
        }
        else {
          this.showDateDetails = true;
        }
      });

      this.showProjectList = true;
    } else {
      let
        urlSplit = currentUrl.split('/'),
        firstPath = urlSplit[1],
        secondPath = urlSplit[2],
        componentData:any = (this.grpdSecondPath && this.grpdSecondPath[secondPath] && this.grpdSecondPath[secondPath][0]) ? this.grpdSecondPath[secondPath][0]['data'] : {};
      this.pageTitle = componentData['title'];

      // if project code not required for this component
      if (componentData.hasOwnProperty('isProjectCodeRequired') && !componentData['isProjectCodeRequired']) {
        this.showProjectList = this.showDateDetails = false;

      } else {
        if (this.commonService.isProjectCodeSelected()) {
          this.showProjectList = this.showDateDetails = true;
          // this.showProjectList = true;

          // hide date details for this modules
          // if (firstPath == 'configuration') {
          //   this.showDateDetails = false;
          // } else {
          //   this.showDateDetails = true;
          // }

        } else {
          this.notificationService.showToast("Select project", "Warning");
          this.redirectToHome();
        }
      }
    }
  }

  redirectToHome() {
    this.pageTitle = "";
    this.showProjectList = this.showDateDetails = true;
    this._router.navigate(['/dashboard/home']);
  }

  selectedProjectChanged(elasticProjModel: IElasticProjRedirectModel) {
    this.edmsProjHeader.changeProjectFromES(elasticProjModel);
  }

}
